<template>
  <pack
    class="banner-card"
    :class="{ 'new-one' : id == 0, 'is-last': isLast, 'is-first': isFirst }"
  >
    <el-form @submit.native.prevent label-position="left" label-width="88px">
      <el-form-item label="图片">
        <zt-input placeholder="请上传图片" width="259px" readonly :value="picture"/>
        <zt-button
          class="ml14"
          plain
          type="primary"
          min-width="82px"
          size="medium"
          @click="onUploadClick"
          :loading="uploadLoading"
        >上传图片</zt-button>
        <input
          type="file"
          accept=".png, .jpg"
          :multiple="false"
          ref="upload"
          @change="onFileChange"
        >
        <p class="tip">※图片尺寸750x300，支持jpg、png格式</p>
      </el-form-item>
      <el-form-item label="跳转链接">
        <zt-input placeholder="请选择跳转方式" width="259px" readonly :value="url"/>
        <zt-button
          class="ml14"
          plain
          type="primary"
          width="82px"
          size="medium"
          @click="onSettingLinkClick"
        >设置链接</zt-button>
      </el-form-item>
      <el-form-item label="生效时间" class="my-data-picker">
        <el-date-picker
          class="data-picker"
          v-model="dataTime"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd  HH:mm:ss"
          prefix-icon="no-icon"
          :editable="false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="btn-box">
        <zt-button
          class="ml14"
          type="primary"
          width="139px"
          @click="onSaveClick"
        >{{ id == 0 ? '添加' : '保存' }}</zt-button>
        <zt-button
          class="ml14"
          plain
          type="primary"
          width="139px"
          @click="onCancelClick"
          v-if="!id"
        >取消</zt-button>
        <div class="tools" v-show="id">
        <span @click="onSortUpClick(id, index)">上移</span>
        <span @click="onSortDownClick(id, index)">下移</span>
        <span @click="onDeleteClick(id)">删除</span>
      </div>
      </el-form-item>
    </el-form>

    <div class="right-box">
      <div class="img-box">
        <img :src="picture" v-if="picture">
        <template v-else>请上传图片</template>
      </div>
      
    </div>

    <!-- <setting-link-dialog
      v-model="visible"
      :url="url"
      @change="onSettingChange"
      class="ignore-elements"
    /> -->

    <CmsEntrySelectPopup
      v-model="visible"
      :value="url"
      @confirm="onSettingChange"
      class="ignore-elements"
    />

  </pack>
</template>

<script>
// import SettingLinkDialog from "@/views/cmsWebSite/components/config/advert/components/SettingLinkDialog";
import { CmsEntrySelectPopup } from '@/components/CmsEntrySelect/index.js'
import { uploadImage } from '@/api/upload';
import { formatDate } from '@/utils/date'
import {
  admin_cms_banner_recommend_add,
  admin_cms_banner_recommend_delete,
  admin_cms_banner_recommend_edit,
  taoke_cms_banner_recommend_add,
  taoke_cms_banner_recommend_delete,
  taoke_cms_banner_recommend_edit
} from '@/api/cmsbanner';
export default {
  name: 'BannerCard',
  components: {
    // SettingLinkDialog,
    CmsEntrySelectPopup,
  },
  props: {
    id: Number, // 有id则是修改，没有id则是新增
    index: Number, // 排序索引
    picture: String, // 图片url
    url: String, // 跳转链接
    add_time: String, //开始时间
    end_time: String||'', //结束时间
    isLast: Boolean,
    isFirst: Boolean,
    overdue:Boolean,
    role: { type: String, default: 'admin' },
  },
  data:function() {
    return{
      defaultTime:[],
      dataTime:[this.add_time, this.end_time||this.defaultEndTime()],
      visible: false,
      uploadLoading: false,
    }
  },
  methods: {
    defaultEndTime() {
      var _time = new Date(this.add_time);
      var _month = _time.getMonth();
      var _year = _time.getFullYear();
      var _day = _time.getDate();
      var _hours = _time.getHours();
      var _minutes = _time.getMinutes();
      var _seconds = _time.getSeconds();
      if (_month == 12) {
        _month = 1;
        _year++;
      } else {
        _month++;
      }
      if (this.end_time == null) {
        return new Date(_year, _month, _day, _hours, _minutes, _seconds);
      } else {
        return this.end_time;
      }
    },
    // 保存点击
    onSaveClick() {
      if (this.id) {
        this.saveEditItem();
      } else {
        this.saveNewItem();
      }
    },
    // 取消点击
    onCancelClick() {
      this.$emit('cancel');
    },
    // 删除
    async onDeleteClick(id) {
      const fn =
        this.role === 'taoke'
          ? taoke_cms_banner_recommend_delete
          : admin_cms_banner_recommend_delete;
      const { data } = await fn({ id });
      if (data.error_code != 0) {
        this.$message.error(data.error_message);
      } else {
        this.$emit('refresh');
      }
    },
    onSortUpClick(id, index) {
      if (this.isFirst) {
        return
      }else if(this.overdue) {
        this.$message({
          message:'轮播图已过期',
          duration:1000,
        })
        return
      } 
      this.$emit('sort-up', { id, index });
    },
    onSortDownClick(id, index) {
      if (this.isLast) {
        return
      }else if(this.overdue) {
        this.$message({
          message:'轮播图已过期',
          duration:1000,
        })
        return
      }
      this.$emit('sort-down', { id, index });
    },
    // 上传图片点击
    onUploadClick() {
      this.$refs.upload.click();
    },
    // input file 文件改变
    async onFileChange({ target }) {
      this.uploadLoading = true;
      const file = target.files[0];

      const { data } = await uploadImage(
        file,
        this.role === 'admin' ? 'admin' : 'taobaoke'
      );
      if (data.error_code == 0) {
        this.$emit('update:picture', data.file);
      } else {
        this.$message.error(data.error_message);
      }
      this.uploadLoading = false;
    },

    // 设置链接弹框
    onSettingLinkClick() {
      this.visible = true;
    },
    // 设置链接弹框选择内容改变
    onSettingChange(event) {
      // console.log(event)
      // this.$emit("update:url", event.originURL);
      this.$emit('update:url', event.fullUrl || event.originURL);
    },

    // 保存新增的item
    async saveNewItem() {
      const params = {
        picture: this.picture,
        url: this.url,
        add_time: formatDate(this.dataTime[0]),
        end_time:formatDate(this.dataTime[1]),
        type: 'CMS首页推荐',
      };
      const fn =
        this.role === 'taoke'
          ? taoke_cms_banner_recommend_add
          : admin_cms_banner_recommend_add;
      const { data } = await fn(params);
      if (!data.error_code) {
        this.$emit('refresh');
        this.$message.success('添加成功');
      } else {
        this.$message.error(data.error_message);
      }
    },

    // 保存编辑的item
    async saveEditItem() {
      const params = {
        picture: this.picture,
        url: this.url,
        id: this.id,
        add_time: formatDate(this.dataTime[0]),
        end_time:formatDate(this.dataTime[1]),
        type: 'CMS首页推荐',
      };
      const fn =
        this.role === 'taoke'
          ? taoke_cms_banner_recommend_edit
          : admin_cms_banner_recommend_edit;
      const { data } = await fn(params);
      if (!data.error_code) {
        this.$emit('refresh');
        this.$message.success('保存成功');
      } else {
        this.$message.error(data.error_message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pack {
  padding: 16px 16px 24px 28px;
  display: flex;
}
.el-form {
  width: 465px;
  display: inline-block;
}
.el-form-item {
  .zt-button {
    // padding: 8px 13px;
    padding-left: 13px;
    padding-right: 13px;
  }
}
.right-box {
  margin-left: 24px;
}

.img-box {
  width: 375px;
  height: 150px;
  border: 1px solid #faf2fc;
  background: #eceff1;
  color: $theme-textsecond;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-bottom: 24px;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.btn-box{
  position: relative;
.tools {
  right: -50%;
  top: 0px;
  position: absolute;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  //margin-left: 87px;
  span {
    margin-left: 40px;
    cursor: pointer;
    width: 96px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: $theme-textsecond;
  }
}
}


.zt-button.is-plain {
  background: transparent;
}
input[type="file"] {
  display: none;
}
.zt-input /deep/ {
  .el-input__inner {
    color: $theme-textmain;

    &:read-only {
      background: #f8fafe;
    }
  }
}

.ml14 {
  margin-left: 14px;
}
.tip {
  color: $theme-textsecond;
  font-size: 12px;
  margin-top: 6px;
  line-height: 17px;
}
.data-picker {
  width: 355px;
}

.no-icon {
  display: none;
}
</style>